<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props:{
    //   Headline: String,
      labels: {
      type: Array,
      default: null},
      dataset: {
      type: Array,
      default: null},
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.dataset,

      },
      { responsive: true, maintainAspectRatio: false ,

 scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  },
                  gridLines: {
                    display: true
                  }
                }],
                xAxes: [ {
                  gridLines: {
                    display: false
                  }
                }]
              },
    
          plugins: {
       
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        // text: this.Headline
      }
    }
      }
    );
  }
};
</script>
